import React, { PureComponent } from 'react'
import { Table, Button } from 'react-bootstrap'
import { openIdentityInfoModalDialog } from '../../actions/identity_info_modal_dialog'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import IdentityInfoModalDialog from './identity_info_modal_dialog'
import ProcessTransactionStartModalDialog from './process_transaction_start_modal_dialog'
import { TX_STATUS_FAILED } from '../../config'
import { openProcessTransactionStartModalDialog } from '../../actions/start_process_transaction'

class TxIdentityInfo extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      copyText: 'Copy Corporate Link',
      copyClass: 'success',
    }
  }

  /**
   * @todo this is a duplication, needs to be generalized
   * @todo should utilize environment variables instead of relying on sub-domain string
   */
  generateLink = () => {
    const subdomain = window.location.hostname.split('.')[0]
    let linkSub = 'dev-kyc'
    if (subdomain === 'compliance') {
      linkSub = 'kyc'
    }
    const baseUrl = 'https://' + linkSub + '.myverify.info/business-onboarding/'
    const identityID = this.props.data.business
    const link = baseUrl + identityID
    let dummy = document.createElement('textarea')
    document.body.appendChild(dummy)
    dummy.value = link
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    this.setState({
      copyText: 'Copied',
      copyClass: 'primary',
    })
  }

  render() {
    let showButton = false
    if (this.props.data.investor_type === 'corporate_entity') {
      showButton = true
    }

    const { openIdentityInfoModalDialog, openProcessTransactionStartModalDialog, mainData } = this.props
    return (
      <div className='ibox float-e-margins section-shadow' style={{ overflowX: 'auto' }}>
        <div className='ibox-title'>
          <h5>Identity Information</h5>
        </div>
        <div className='ibox-content table-responsive'>
          <Table striped bordered hover>
            <tbody>
              <tr>
                <th>Name</th>
                <td>
                  {this.props.data.first_name || this.props.data.lastname || this.props.data.middle_name
                    ? (this.props.data.first_name || '') +
                      ' ' +
                      (this.props.data.middle_name || '') +
                      ' ' +
                      (this.props.data.last_name || '')
                    : ''}
                </td>
              </tr>
              <tr>
                <th>Alias</th>
                <td>{this.props.data.alias}</td>
              </tr>
              <tr>
                <th>Gender</th>
                <td>{this.props.data.gender}</td>
              </tr>
              <tr>
                <th>Birth Date</th>
                <td>{this.props.data.birth_date}</td>
              </tr>
              <tr>
                <th>Birth Location</th>
                <td>{this.props.data.birth_location}</td>
              </tr>
              {this.props.data.death_date && (
                <tr>
                  <th>Death Date</th>
                  <td>{this.props.data.death_date}</td>
                </tr>
              )}
              <tr>
                <th>Height</th>
                <td>{this.props.data.height}</td>
              </tr>
              <tr>
                <th>Weight</th>
                <td>{this.props.data.weight}</td>
              </tr>
              <tr>
                <th>Eye Color</th>
                <td>{this.props.data.eye_color}</td>
              </tr>
              <tr>
                <th>Hair Color</th>
                <td>{this.props.data.hair_color}</td>
              </tr>
              <tr>
                <th>Driver&apos;s License</th>
                <td>{this.props.data.drivers_license}</td>
              </tr>
              <tr>
                <th>Passport Number</th>
                <td>{this.props.data.passport_number}</td>
              </tr>
              <tr>
                <th>Social Security Number</th>
                <td>{this.props.data.ssn}</td>
              </tr>
              <tr>
                <th>Investor Type</th>
                <td>
                  {this.props.data.investor_type}
                  {showButton && (
                    <Button
                      style={{ float: 'right', width: 140 }}
                      size={'sm'}
                      variant={this.state.copyClass}
                      onClick={this.generateLink}
                    >
                      {this.state.copyText}
                    </Button>
                  )}
                </td>
              </tr>
              <tr>
                <th>Signer Type</th>
                <td>{this.props.data.signer_type}</td>
              </tr>
            </tbody>
          </Table>
          <div className='text-center'>
            <button
              className='btn btn-info shadow'
              type='button'
              onClick={() => openIdentityInfoModalDialog(mainData.id)}
            >
              <i className='fa fa-paste' /> Edit
            </button>
            {mainData.state === TX_STATUS_FAILED && (
              <button
                onClick={() => openProcessTransactionStartModalDialog(mainData.id)}
                className='btn btn-warning m-l-sm shadow'
              >
                <i className='fa fa-play-circle' /> Process Transaction
              </button>
            )}
          </div>
        </div>
        <IdentityInfoModalDialog identityData={this.props.data} />
        <ProcessTransactionStartModalDialog txId={mainData.id} />
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openIdentityInfoModalDialog,
      openProcessTransactionStartModalDialog,
    },
    dispatch
  )

export default withRouter(connect(null, mapDispatchToProps)(TxIdentityInfo))
